<template>
  <div id="proposta_passo4"  style="background:white;">
    <el-row type="flex" class="nao_imprimir">
      <el-col :span="24" style="text-align:right">
        <el-button
          style="margin-top: 12px; text-align: left;"
          type="primary"
          size="small"
          round
          plain
          @click="anterior"
          :disabled="botao_anterior_finalizar"
        >
          <i class="el-icon-d-arrow-left"></i> Anterior
        </el-button>
        <el-button
          style="margin-top: 12px;"
          type="primary"
          round
          size="medium"
          @click="imprimir"
          :disabled="disable_right"
        >
          Imprimir Proposta
        </el-button>
        <el-button
          style="margin-top: 12px;"
          type="danger"
          round
          size="medium"
          @click="finalizar"
          :disabled="botao_anterior_finalizar"
        >
          Concluir
        </el-button>
      </el-col>
    </el-row>
    <el-row class="nao_imprimir">
      <el-col :span="20" >
        <p>Passo 4 - Visualizar Proposta</p>
      </el-col>
    </el-row>
    <el-row class="imprimir " >
      <el-col :span="24">
          <el-row class="imprimir primeira_folha" style="background:white;">
            <el-col>
              <el-row class="content-block" >
                <el-col :span="24">
                  <!-- Página 1 - apresentação da proposta -->
                  <el-row>
                    <el-col :span="12" v-html="ruleForm.orcamento_versao" class="texto_esquerda">
                    </el-col>
                    <el-col :span="12" v-html="ruleForm.dataproposta" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="ruleForm.orcamento_cliente" class="texto_esquerda">
                      
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col v-html="ruleForm.orcamento_local" :span="24" class="texto_esquerda">
                      
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" class="texto_esquerda">
                      <h3 style="font-size:14px; margin:5px;">A/C:</h3>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" class="texto_esquerda">
                      <h3 style="font-size:14px; margin:5px;">E-mail:</h3>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" class="texto_esquerda">
                      <h3 style="font-size:14px; margin:5px;">Telefone:</h3>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="propostatitulo"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="propostasubtitulo"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="propost"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" v-html="ruleForm.supervisor" class="texto_esquerda"></el-col>
                    <el-col v-html="ruleForm.tecnico" :span="12" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" class="texto_esquerda">
                      <table class="tamanho_tabela">
                        <tr>
                          <th>Histórico de Revisões</th>
                          <th>Rev.</th>
                          <th>Orc.</th>
                          <th>Data</th>
                        </tr>
                        <tr v-for="item in dadosRevisoes" v-bind:key="item.id">
                          <td>{{item.descricao}}</td>
                          <td>{{item.revisao}}</td>
                          <td>{{item.orcamento}}</td>
                          <td>{{item.data}}</td>
                        </tr>
                      </table>
                    </el-col>
                  </el-row>                  
                </el-col>
              </el-row>
              <!-- página 2 - apresentação -->
              <el-row class="nao_imprimir">
                <el-col :span="24">
                  <el-divider>
                    <i class="el-icon-more-outline"></i>
                  </el-divider>
                </el-col>
              </el-row>
              <el-row class="content-block">
                <el-col :span="24">
                  <el-row>
                    <el-col :span="24" v-html="tituloapresentacao" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="subtituloapresentacao" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="apresentac" class="texto_esquerda"></el-col>
                  </el-row>
                </el-col>
              </el-row>
              <!-- página 3 - conteudo da proposta -->
              <el-row class="nao_imprimir">
                <el-col :span="24">
                  <el-divider>
                    <i class="el-icon-more-outline"></i>
                  </el-divider>
                </el-col>
              </el-row>
              <el-row class="content-block">
                <el-col :span="24">
                  <el-row>
                    <el-col :span="24" v-html="tituloproposta" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="subtituloproposta" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="propostacomerc" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="titulovalores" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="subtitulovalores" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" class="texto_esquerda">
                      <table  class="tamanho_tabela">
                        <tr>
                          <th>Item</th>
                          <th>Descrição</th>
                          <th>NCM</th>
                          <th>ICMS</th>
                          <th>IPI</th>
                          <th>Valor s/IPI</th>
                          <th>Valor c/IPI</th>
                        </tr>
                        <tr>
                          <td>{{dadosOrcamento[0].item}}</td>
                          <td>{{dadosOrcamento[0].descricao}}</td>
                          <td>{{dadosOrcamento[0].ncm}}</td>
                          <td>{{dadosOrcamento[0].icms}}</td>
                          <td>{{dadosOrcamento[0].ipi}}</td>
                          <td class='texto_direita'>{{dadosOrcamento[0].valorsemipi}}</td>
                          <td class="texto_direita">{{dadosOrcamento[0].valorcomipi}}</td>
                        </tr>
                      </table>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="tituloimpostos" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="subtituloimpostos" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="ruleForm.impostos" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="titulopagamento" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="subtitulopagamento" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row >
                    <el-col :span="24" v-html="ruleForm.pagamento" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row >
                    <el-col :span="24" v-html="titulofrete" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24"  v-html="subtitulofrete" class="texto_esquerda" ></el-col>
                  </el-row>
                  <el-row class="content-block">
                    <el-col :span="24"  v-html="ruleForm.frete" class="texto_esquerda"></el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="24" v-html="titulogarantia" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="subtitulogarantia" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="ruleForm.garantia" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="titulovalidade" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="subtitulovalidade" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="ruleForm.validade" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="tituloentrega" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="subtituloentrega" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row >
                    <el-col :span="24" v-html="ruleForm.entrega" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="tituloaceite" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" v-html="subtituloaceite" class="texto_esquerda"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" v-html="ruleForm.aceite" class="texto_esquerda"></el-col>
                    <el-col :span="12" v-html="ruleForm.aceite2" class="texto_esquerda"></el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
    <div class='cabecalho'>
      <el-row>
        <el-col :span="8" style="text-align:left;">
      <el-image :src="src" style="width: 150px; margin-top:20px;"></el-image>
        </el-col>
        <el-col :span="8" >
      <p style="text-align:center; margin-top:40px;">NBRTec Indústria de Equipamentos Elétricos Ltda.</p>
        </el-col>
        <el-col :span="8" style="text-align:right;">
                 <el-image :src="src_qr" style="width: 100px; "></el-image>
        </el-col>
      </el-row>      
    </div>          
      </el-col>
    </el-row>
    <footer>
      <el-row>
        <el-col :span="8">
                 <p style="text-align:left;">Endereço: Rua Erica, 315 / Sala B</p>
       <p style="text-align:left;">Panambi/RS</p>

        </el-col>
        <el-col :span="5">
                 <p style="text-align:left;">(55) 3375-7773</p>
       <p style="text-align:left;">www.nbrtec.com.br</p>

        </el-col>
        <el-col :span="11">
                 <p style="text-align:left;">NBRTec Indústria de Equipamentos Elétricos Ltda.</p>
        </el-col>
      </el-row>
    </footer>    
    <div id="fundo" >
        <el-image :src="src_peb" style="width: 500px; margin-top:400px; opacity:0.1; "></el-image>
    </div>      
  </div>
</template>

<script>

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

import axios from "axios";
import FuncoesUteis from "../../../plugins/FuncoesUteis";

export default {
  props: {
    proposta_id: [Number],
  },
  data() {
    return {
      src:"/static/logo.png",
      src_qr:"/static/qrcode.png",
      src_peb:"/static/logo_p&b.png",
      dadosRevisoes:[],
      dadosOrcamento:[{
          item: '1',
          descricao: '',
          ncm: '',
          icms: '',
          ipi: '',
          valorsemipi: '',
          valorcomipi: '',
        },
      ],
      botao_anterior_finalizar:false,
      disable_right: false,
      propost:'',
      propostatitulo:'',
      propostasubtitulo:'',
      apresentac:'',
      propostacomerc:'',
      tituloproposta:'',
      subtituloproposta:'',
      tituloimpostos:'',
      titulovalores:'',
      subtitulovalores:'',
      subtituloimpostos:'',
      titulopagamento:'',
      subtitulopagamento:'',
      titulofrete:'',
      subtitulofrete:'',
      titulogarantia:'',
      subtitulogarantia:'',
      titulovalidade:'',
      subtitulovalidade:'',
      tituloaceite:'',
      subtituloaceite:'',
      tituloentrega:'',
      subtituloentrega:'',
      tituloapresentacao:'',
      subtituloapresentacao:'',
      ruleForm: [
        {
          orcamento_versao:"",//1
          orcamento_cliente:"",//1
          orcamento_local:"",//1
          dataproposta: "", //1
          tecnico: "", //1
          supervisor: "", //1
          proposta_titulo: "", //1
          proposta_subtitulo: "", //1
          proposta: "", //1
          apresentacao: "", //2
          apresentacao_titulo: "", //2
          apresentacao_subtitulo: "", //2
          propostacomercial_titulo: "", //3
          propostacomercial_subtitulo: "", //3
          propostacomercial: "", //3
          valores_titulo:"", //3
          valores_subtitulo:"",//3
          impostos: "", //3
          impostos_titulo: "", //3
          impostos_subtitulo: "", //3
          pagamento: "", //3
          pagamento_titulo: "", //3
          pagamento_subtitulo: "", //3
          frete: "", //3
          frete_titulo: "", //3
          frete_subtitulo: "", //3
          garantia: "", //3
          garantia_titulo: "", //3
          garantia_subtitulo: "", //3
          validade: "", //3
          validade_titulo: "", //3
          validade_subtitulo: "", //3
          entrega: "", //3
          entrega_titulo: "", //3
          entrega_subtitulo: "", //3
          aceite_titulo: "", //3
          aceite_subtitulo: "", //3
          aceite: "", //3
          aceite2: "", //3
        },
      ],
    };
  },
  
  mounted() {
    //PÁGINA 1 - APRESENTAÇÃO PROPOSTA
    let dados = {
      pagina_pagina: "1",
      
    };
    axios
      .post(url + "/proposta/" + this.proposta_id, dados, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          if(resp.data.proposta.status == 'C'){
            this.botao_anterior_finalizar = true;
          } else {
            this.botao_anterior_finalizar = false;
          }
          for (let i = 0; i < resp.data.pagina.length; i++) {
            switch (resp.data.pagina[i].slug) {
              case "titulo":
                this.ruleForm.proposta_titulo = resp.data.pagina[i].texto;
                break;
              case "subtitulo":
                this.ruleForm.proposta_subtitulo = resp.data.pagina[i].texto;
                break;
              case "proposta":
                this.ruleForm.proposta = resp.data.pagina[i].texto;
                break;
              case "supervisor":
                this.ruleForm.supervisor = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'</div>';
                break;
              case "tecnico":
                this.ruleForm.tecnico = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'</div>';
                break;
            }
          }
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message: "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      })
      .finally(()=>{
        this.propost = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+this.ruleForm.proposta+'</div>';
        this.propostatitulo = '<h1 style="font-size:20px; margin:5px;">'+this.ruleForm.proposta_titulo+'</h1>';
        if(this.ruleForm.proposta_subtitulo != null)
          this.propostasubtitulo = '<h2 style="font-size:16px; margin:5px; margin-bottom:30px;">'+this.ruleForm.proposta_subtitulo+'</h2>';
      });

    //PÁGINA 2 - APRESENTAÇÃO
    let dados2 = {
      pagina_pagina: "2",
    };
    axios
      .post(url + "/proposta/" + this.proposta_id, dados2, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
           let data = resp.data.proposta.created_at;
           let ano = data.substr(0, 4);
           let mes = data.substr(5, 2);
           let dia = data.substr(8, 2);
          switch(mes){
            case '01': mes = 'Janeiro'; break;
            case '02': mes = 'Fevereiro'; break;
            case '03': mes = 'Março'; break;
            case '04': mes = 'Abril'; break;
            case '05': mes = 'Maio'; break;
            case '06': mes = 'Junho'; break;
            case '07': mes = 'Julho'; break;
            case '08': mes = 'Agosto'; break;
            case '09': mes = 'Setembro'; break;
            case '10': mes = 'Outubro'; break;
            case '11': mes = 'Novembro'; break;
            case '12': mes = 'Dezembro'; break;
          }
          this.ruleForm.dataproposta = '<h3 style="font-size:14px;  margin:5px;">Panambi, '+dia+' de '+mes+' de '+ano+'.</h3>';
          this.ruleForm.orcamento_versao = '<h3 style="font-size:14px;  margin:5px;">Proposta NBRTec: - Versão: '+resp.data.orcamento.revisao+'</h3>';
          this.ruleForm.orcamento_cliente = '<h3 style="font-size:14px; margin:5px;">Cliente: '+resp.data.orcamento.cliente+'</h3>';
          this.ruleForm.orcamento_local = '<h3 style="font-size:14px; margin:5px;">Local: '+resp.data.orcamento.cidade+'/'+resp.data.orcamento.estado+'</h3>';

          //tabela valores 2. compilação de valores
          this.dadosOrcamento[0].item = '1';
          this.dadosOrcamento[0].descricao = resp.data.orcamento.ncm_descricao;
          this.dadosOrcamento[0].ncm = resp.data.orcamento.ncm_ncm;
          this.dadosOrcamento[0].valorcomipi = 'R$ '+FuncoesUteis.formataDolarToReal(resp.data.orcamento.venda_com_ipi);
          this.dadosOrcamento[0].valorsemipi = 'R$ '+FuncoesUteis.formataDolarToReal(resp.data.orcamento.venda_sem_ipi);

          for(let imp=0;imp<resp.data.orcamentoTributos.length;imp++){
            if(resp.data.orcamentoTributos[imp].slug == 'icms'){
              this.dadosOrcamento[0].icms = resp.data.orcamentoTributos[imp].percentual+'%';
            }
            if(resp.data.orcamentoTributos[imp].slug == 'ipi'){
              this.dadosOrcamento[0].ipi = resp.data.orcamentoTributos[imp].percentual+'%';
            }
          }

          for (let i = 0; i < resp.data.pagina.length; i++) {
            switch (resp.data.pagina[i].slug) {
              case "titulo":
                this.ruleForm.apresentacao_titulo = resp.data.pagina[i].texto;
                break;
              case "subtitulo":
                this.ruleForm.apresentacao_subtitulo = resp.data.pagina[i].texto;
                break;
              case "apresentacao":
                this.ruleForm.apresentacao = resp.data.pagina[i].texto;
                break;
            }
          }
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message: "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      })
      .finally(()=>{
        this.apresentac = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+this.ruleForm.apresentacao+'</div>';
        if(this.ruleForm.apresentacao_subtitulo != 'null' && this.ruleForm.apresentacao_subtitulo != undefined)
          this.subtituloapresentacao = '<h2 style="font-size:16px; margin:5px;">'+this.ruleForm.apresentacao_subtitulo+'</h2>';
        this.tituloapresentacao = '<h1 style="font-size:20px; margin:5px; text-align:center">'+this.ruleForm.apresentacao_titulo+'</h1>';
      });

    //PÁGINA 3 - CONTEÚDO
    let dados3 = {
      pagina_pagina: "3",
    };
    axios
      .post(url + "/proposta/" + this.proposta_id, dados3, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          if(resp.data.revisoes.length>0){
            let d, dia, mes, ano;
           for(let r=0;r<resp.data.revisoes.length;r++){
            d = resp.data.revisoes[r].created_at.substr(0,10);
            ano = d.substr(0,4); 
            mes = d.substr(5,2); 
            dia = d.substr(8,2); 
            
            this.dadosRevisoes.push({
              id: resp.data.revisoes[r].id,
              descricao: resp.data.revisoes[r].sge_orcamento,
              revisao: resp.data.revisoes[r].revisao,
              orcamento: resp.data.revisoes[r].revisao,
              data: dia+'-'+mes+'-'+ano,
            });
           }
         }

          for (let i = 0; i < resp.data.pagina.length; i++) {
            switch (resp.data.pagina[i].slug) {
              case "tituloproposta":
                this.ruleForm.propostacomercial_titulo = resp.data.pagina[i].texto;
                break;
              case "subtituloproposta":
                this.ruleForm.propostacomercial_subtitulo = resp.data.pagina[i].texto;
                break;
              case "proposta":
                this.ruleForm.propostacomercial = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'</div>';
                break;
              case "titulovalores":
                this.ruleForm.valores_titulo = resp.data.pagina[i].texto;
                break;
              case "subtitulovalores":
                this.ruleForm.valores_subtitulo = resp.data.pagina[i].texto;
                break;
              case "tituloimpostos":
                this.ruleForm.impostos_titulo = resp.data.pagina[i].texto;
                break;
              case "subtituloimpostos":
                this.ruleForm.impostos_subtitulo = resp.data.pagina[i].texto;
                break;
              case "impostos":
                this.ruleForm.impostos = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'<div>';
                break;
              case "pagamento":
                this.ruleForm.pagamento = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'</div>';
                break;
              case "titulopagamento":
                this.ruleForm.pagamento_titulo = resp.data.pagina[i].texto;
                break;
              case "subtitulopagamento":
                this.ruleForm.pagamento_subtitulo = resp.data.pagina[i].texto;
                break;
              case "frete":
                this.ruleForm.frete = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'</div>';
                break;
              case "titulofrete":
                this.ruleForm.frete_titulo = resp.data.pagina[i].texto;
                break;
              case "subtitulofrete":
                this.ruleForm.frete_subtitulo = resp.data.pagina[i].texto;
                break;
              case "garantia":
                this.ruleForm.garantia = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'</div>';
                break;
              case "titulogarantia":
                this.ruleForm.garantia_titulo = resp.data.pagina[i].texto;
                break;
              case "subtitulogarantia":
                this.ruleForm.garantia_subtitulo = resp.data.pagina[i].texto;
                break;
              case "validade":
                this.ruleForm.validade = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'</div>';
                break;
              case "titulovalidade":
                this.ruleForm.validade_titulo = resp.data.pagina[i].texto;
                break;
              case "subtitulovalidade":
                this.ruleForm.validade_subtitulo = resp.data.pagina[i].texto;
                break;
              case "tituloentrega":
                this.ruleForm.entrega_titulo = resp.data.pagina[i].texto;
                break;
              case "subtituloentrega":
                this.ruleForm.entrega_subtitulo = resp.data.pagina[i].texto;
                break;
              case "entrega":
                this.ruleForm.entrega = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'</div>';
                break;
              case "tituloaceite":
                this.ruleForm.aceite_titulo = resp.data.pagina[i].texto;
                break;
              case "subtituloaceite":
                this.ruleForm.aceite_subtitulo = resp.data.pagina[i].texto;
                break;                
              case "aceite":
                this.ruleForm.aceite = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'</div>';
                break;
              case "aceite2":
                this.ruleForm.aceite2 = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+resp.data.pagina[i].texto+'</div>';
                break;
            }
          }
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message: "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      })
      .finally(()=>{
        this.propostacomerc = '<div style="font-size:14px; margin-top:30px; text-align:justify">'+this.ruleForm.propostacomercial+'</div>';
        this.tituloproposta = '<h1 style="font-size:20px; margin:5px; text-align:left">'+this.ruleForm.propostacomercial_titulo+'</h1>';
        if(this.ruleForm.propostacomercial_subtitulo != 'null' && this.ruleForm.propostacomercial_subtitulo != undefined)
          this.subtituloproposta = '<h2 style="font-size:16px; margin:5px; text-align:left">'+this.ruleForm.propostacomercial_subtitulo+'</h2>';
        this.titulovalores = '<h1 style="font-size:20px; margin:5px; text-align:left">'+this.ruleForm.valores_titulo+'</h1>';
        if(this.ruleForm.valores_subtitulo != 'null' && this.ruleForm.valores_subtitulo != undefined)
          this.subtitulovalores = '<h2 style="font-size:16px; margin:5px; text-align:left">'+this.ruleForm.valores_subtitulo+'</h2>';
        this.tituloimpostos = '<h1 style="font-size:20px; margin:5px; text-align:left">'+this.ruleForm.impostos_titulo+'</h1>';
        if(this.ruleForm.impostos_subtitulo != 'null' && this.ruleForm.impostos_subtitulo != undefined)
          this.subtituloimpostos = '<h2 style="font-size:16px; margin:5px; text-align:left">'+this.ruleForm.impostos_subtitulo+'</h2>';
        this.titulopagamento = '<h1 style="font-size:20px; margin:5px; text-align:left">'+this.ruleForm.pagamento_titulo+'</h1>';
        if((this.ruleForm.pagamento_subtitulo != 'null')&&(this.ruleForm.pagamento_subtitulo != undefined))
          this.subtitulopagamento = '<h2 style="font-size:16px; margin:5px; text-align:left">'+this.ruleForm.pagamento_subtitulo+'</h2>';
        this.titulofrete = '<h1 style="font-size:20px; margin:5px; text-align:left">'+this.ruleForm.frete_titulo+'</h1>';
        if(this.ruleForm.frete_subtitulo != 'null' && this.ruleForm.frete_subtitulo != undefined)
          this.subtitulofrete = '<h2 style="font-size:16px; margin:5px; text-align:left">'+this.ruleForm.frete_subtitulo+'</h2>';
        this.titulogarantia = '<h1 style="font-size:20px; margin:5px; text-align:left">'+this.ruleForm.garantia_titulo+'</h1>';
        if(this.ruleForm.garantia_subtitulo != 'null' && this.ruleForm.garantia_subtitulo != undefined)
          this.subtitulogarantia = '<h2 style="font-size:16px; margin:5px; text-align:left">'+this.ruleForm.garantia_subtitulo+'</h2>';
        this.titulovalidade = '<h1 style="font-size:20px; margin:5px; text-align:left">'+this.ruleForm.validade_titulo+'</h1>';
        if(this.ruleForm.validade_subtitulo != 'null' && this.ruleForm.validade_subtitulo != undefined)
          this.subtitulovalidade = '<h2 style="font-size:16px; margin:5px; text-align:left">'+this.ruleForm.validade_subtitulo+'</h2>';
        this.tituloentrega = '<h1 style="font-size:20px; margin:5px; text-align:left">'+this.ruleForm.entrega_titulo+'</h1>';
        if(this.ruleForm.entrega_subtitulo != 'null' && this.ruleForm.entrega_subtitulo != undefined)
          this.subtituloentrega = '<h2 style="font-size:16px; margin:5px; text-align:left">'+this.ruleForm.entrega_subtitulo+'</h2>';
        this.tituloaceite = '<h1 style="font-size:20px; margin:5px; text-align:left">'+this.ruleForm.aceite_titulo+'</h1>';
        if(this.ruleForm.aceite_subtitulo != 'null' && this.ruleForm.aceite_subtitulo != undefined)
          this.subtituloaceite = '<h2 style="font-size:16px; margin:5px; text-align:left">'+this.ruleForm.aceite_subtitulo+'</h2>';
      });
  },
  methods: {
    imprimir(){
      window.print();
    },
    finalizar(){
      axios
        .get(url + "/propostafinalizar/"+ this.proposta_id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          this.$notify({
            title: "Sucesso",
            message: "Registro salvo com Sucesso!",
            type: "success",
          });

          let prop;
          prop = resp.data.id;
          let dado = {
            active: 0,
            proposta: prop,
          };
          this.$emit("button-click", dado);
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });       
      
    },
    anterior() {
      let dado = {
        active: 3,
        proposta: this.proposta_id,
      };
      this.$emit("button-click", dado);
    },
  },
};
</script>
<style scoped>
#proposta_passo4 .texto_esquerda {
  text-align: left;
  margin-top: 0px;
  margin-bottom: 0px;
}

#proposta_passo4 .texto_direita {
  text-align: right;
}

#proposta_passo4 .texto_esquerda h3 {
  text-align: left;
  margin-top: 0px;
  margin-bottom: 0px;
 
}

/***********************************************************/
#proposta_passo4 footer {
  display: none;
}
#proposta_passo4 .cabecalho {
   display: none;
}
#proposta_passo4 #fundo {
   display: none;
}

.tamanho_tabela{
  margin-top: 10px;
  margin-bottom: 20px;;
  width: 90%;
  border:1px solid #E4E7ED;
  border-collapse: collapse;
}

.tamanho_tabela th, .tamanho_tabela td{
  border:1px solid #E4E7ED;
  padding: 5px;;
}

.tamanho_tabela th{
  text-align: center;
}

@page {
  size: A4;
  margin: 11mm 17mm 17mm 17mm;
}
html, body{
      background:white!important;
  }
@media print {
 .nao_imprimir{
    display: none;
  }
  .imprimir{
    display: block;
  }  
#proposta_passo4 #fundo {
  z-index: 1;
    position: fixed;
    top: 0;
    display: block;
    width: 99%;
    height: 1000px;
}  
#proposta_passo4 #fundo img{
  margin-top: 200px;
}  
  #proposta_passo4 footer {
    position: fixed;
    bottom: 0;
    display: block;
    float:left;
    width: 99%;
    border-top:1px solid black;
    font-size: 13px;
  }
  #proposta_passo4 .cabecalho {
    position: fixed;
    top: 0;
    display: block;
    float:left;
    width: 99%;
    border-bottom:1px solid black;
    background: white;
    font-size: 13px;;
  }
  #proposta_passo4 .content-block {
    page-break-after: always; /* Always insert page break after this element */
    page-break-inside: avoid;
    position: relative;
    /* opacity: 0.2;
    background: url(http://10.1.1.45:8080/static/logo.png) no-repeat center center;
background-size:  300px 100px; */
  }
  #proposta_passo4 .primeira_folha{
    top:120px;
    font-size: 16px;
  }
  .tamanho_tabela{
    width: 100%;
  }
  html, body {
    width: 210mm;
    height: 297mm;
  }
  body{
      background:white;
  }
}
</style>